module.exports = __webpack_public_path__ + "img/csr_swiper_06.1de2988e.jpg";